import getCookie from '../getCookie';

const getBrowserCookieId = () => {
  return getCookie('BrowserCookieId');
};

export default getBrowserCookieId;
